// Utility function to handle asset paths for deployment
export const getAssetPath = (path) => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    const basePath = process.env.PUBLIC_URL || '';
    return `${basePath}/${cleanPath}`;
};

// Convert a product name into a URL-safe slug
const nameToSlug = (name) =>
    name
        .toLowerCase()
        .replace(/[^a-z0-9\s&]/g, '')
        .replace(/\s*&\s*/g, '-and-')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

// Generate a clean product URL: /products/product/outdoor-bar-set-326
export const createProductUrl = (id, name) =>
    `/products/product/${nameToSlug(name)}-${id}`;

// Extract the numeric product ID from a slug (handles "name-326" and legacy "326")
export const extractProductId = (productSlug) => {
    if (!productSlug) return null;
    const match = productSlug.match(/-(\d+)$/);
    if (match) return parseInt(match[1], 10);
    if (/^\d+$/.test(productSlug)) return parseInt(productSlug, 10);
    return null;
};
